import React from "react";
import { motion } from "framer-motion";

// Single scroll-reveal primitive so every section animates consistently.
// `dir` picks the direction the content travels in from.
const offsets = {
  up: { y: 44, x: 0 },
  down: { y: -44, x: 0 },
  left: { y: 0, x: -48 },
  right: { y: 0, x: 48 },
  none: { y: 0, x: 0 },
};

const Reveal = ({
  children,
  dir = "up",
  delay = 0,
  duration = 0.65,
  amount = 0.15,
  once = true,
  className,
  stagger,
  ...rest
}) => {
  const from = offsets[dir] || offsets.up;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, ...from }}
      whileInView={{ opacity: 1, y: 0, x: 0 }}
      viewport={{ once, amount }}
      transition={{
        duration,
        delay,
        ease: [0.21, 0.6, 0.35, 1],
        ...(stagger ? { staggerChildren: stagger } : {}),
      }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

// Child variant for use inside a Reveal that sets `stagger`.
export const revealItem = {
  hidden: { opacity: 0, y: 22 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

export default Reveal;
